
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AppData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AppData"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appSettings"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"supportedCurrencies"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"symbol"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"currencyTable"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseCurrency"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"date"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"items"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"symbol"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"rate"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"contactInfo"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"phone"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"whatsapp"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"instagram"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"twitter"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"facebook"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"snapchat"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"mapUrl"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"address"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"paymentConfig"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentConfigType"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"termsAndConditions"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LocalisedData"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"privacyPolicy"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LocalisedData"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"introVideos"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lang"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"currentDateTime"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"utcDateTime"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserBasic"},"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"subRoles"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SubRoleBasic"},"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"subscriptionInfo"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subscriptionId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"subscriptionEndDate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"subscriptionFeatures"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hasSubscription"},"arguments":[],"directives":[]}]}}]}},{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getAppData"},"variableDefinitions":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getAppData"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AppData"},"directives":[]}]}}]}}],"loc":{"start":0,"end":1003}};
    doc.loc.source = {"body":"#import \"../fragment/localisedData.gql\"\n#import \"../../../user-module/api/fragment/userBasic.gql\"\n#import \"../../../user-module/api/fragment/subRoleBasic.gql\"\n\nfragment AppData on AppData {\n  appSettings {\n    supportedCurrencies {\n      symbol\n    }\n    currencyTable {\n      baseCurrency\n      date\n      items {\n        symbol\n        rate\n      }\n    }\n    contactInfo {\n      email\n      phone\n      whatsapp\n      instagram\n      twitter\n      facebook\n      snapchat\n      mapUrl\n      address\n    }\n    paymentConfig {\n      paymentConfigType\n    }\n    termsAndConditions {\n      ...LocalisedData\n    }\n    privacyPolicy {\n      ...LocalisedData\n    }\n    introVideos {\n      _id\n      lang\n      url\n    }\n  }\n  currentDateTime {\n    utcDateTime\n  }\n  user {\n    ...UserBasic\n    subRoles {\n      ...SubRoleBasic\n    }\n  }\n  subscriptionInfo {\n    subscriptionId\n    subscriptionEndDate\n    subscriptionFeatures\n    hasSubscription\n  }\n}\n\nquery getAppData {\n  getAppData {\n    ...AppData\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(require("../fragment/localisedData.gql").definitions));
doc.definitions = doc.definitions.concat(unique(require("../../../user-module/api/fragment/userBasic.gql").definitions));
doc.definitions = doc.definitions.concat(unique(require("../../../user-module/api/fragment/subRoleBasic.gql").definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["AppData"] = oneQuery(doc, "AppData");
        
        module.exports["getAppData"] = oneQuery(doc, "getAppData");
        
